import CONSTANT from '../../constants'
import fetchWithAuthorizationHeader from '../../helper/fetchWithAuthorizationHeader'
import type { MultiTenantCreateRequest } from '../../types/multiTenantRequest'

const { MULTI_TENANT_REQUESTS_API_URL } = CONSTANT

const createMultiTenantRequest = async (
	newRequest: MultiTenantCreateRequest
): Promise<any> => {
	const response = await fetchWithAuthorizationHeader(
		`${MULTI_TENANT_REQUESTS_API_URL}`,
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				action: 'CREATE'
			},
			body: JSON.stringify(newRequest)
		}
	)
	return response.json()
}

export default createMultiTenantRequest
